<template>
	<div :class="['radio-button', typeClassName]">
		<input
			class="radio-button__input"
			type="radio"
			:name="name"
			:checked="isActive"
			:disabled="disabled"
			:id="`${uid}_radiobutton`"
			:value="value"
			@input="updateActiveButton"
		/>
		<label
			class="radio-button__label"
			v-if="labelText"
			:for="uid + '_radiobutton'"
		>
			<span class="radio-button__label-text">{{ labelText }}</span>
			<div
				class="radio-button__label-subcontent"
				data-test="radio-button-subcontent"
				v-if="subcontent"
			>
				<slot name="subcontent" />
			</div>
		</label>
	</div>
</template>

<script>
export default {
	name: 'Radiobutton',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [String, Number, Boolean],
			default: true
		},
		labelText: {
			type: String,
			default: ''
		},
		isActive: {
			type: Boolean,
			default: false
		},
		variant: {
			type: String,
			default: '',
			validator(value) {
				return ['', 'stylized', 'paragraph'].includes(value);
			}
		},
		subcontent: {
			type: String,
			default: null
		}
	},
	computed: {
		typeClassName() {
			return 'radio-button--' + this.variant;
		}
	},
	methods: {
		updateActiveButton() {
			return this.$emit('input', this.value);
		}
	}
};
</script>

<style lang="scss">
/**
    * [Description]
    * 
    * Global Radiobuttons
    * Can use SCSS variables = TRUE
    *
    * All radiobuttons styles and variations are included here.
    *
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_form.scss';

.radio-button {
	@include create-check-element('.radio-button__input', 16px, 16px, 50%);
	align-items: flex-start;

	.radio-button__label,
	.radio-button__label-text {
		line-height: 18px;
	}
}

.radio-button__input {
	margin-top: 1px;
	&:checked {
		&::after {
			content: '';
			@include vertical-horizontal-center-with-transform;
			@include create-circle(8px, 8px, $accent-text-dark);
		}
	}
}

/*------------------------------------*\
  #STYLIZED
\*------------------------------------*/

@import '@/scss/5-objects/_cards.scss';

.radio-button--stylized {
	position: relative;

	.radio-button__label {
		@include card('stylized');
		margin-left: 0;
		padding-left: 36px;
	}

	.radio-button__input {
		position: absolute;
		top: 10px;
		left: 12px;
	}

	.radio-button__label-text {
		@include body-text('regular-emphasis');
		text-transform: capitalize;
	}

	.radio-button__label-subcontent {
		@include body-text('regular');
		margin-top: $gutter-sm;
	}

	.radio-button__label,
	.radio-button__label-text,
	.radio-button__label-subcontent {
		line-height: 20px;
	}
}
</style>
